import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { BadgeType } from 'ui/badge/BadgeType';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';

const Badge: FC<PropsWithChildren<BadgeType>> = ({
  children,
  sizeLg,
  pill,
  square,
  additionalClassName,
  variant = Variant.ivory,
  textColor,
  text,
}) => {
  const renderText = () => {
    if (!text) {
      return null;
    }

    return <span className="ml-4p">{text}</span>;
  };

  return (
    <div
      className={classNames(
        `badge badge-${variant}`,
        textColor,
        additionalClassName,
        { 'badge-lg': sizeLg },
        { 'badge-pill': pill },
        { 'badge-square': square },
      )}
    >
      {children}
      {renderText()}
    </div>
  );
};

export { Badge };
